import { render, staticRenderFns } from "./testingToolsSWAL.vue?vue&type=template&id=1809aa35"
import script from "./testingToolsSWAL.vue?vue&type=script&lang=js"
export * from "./testingToolsSWAL.vue?vue&type=script&lang=js"
import style0 from "./testingToolsSWAL.vue?vue&type=style&index=0&id=1809aa35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports